import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomerService } from 'src/customer/services/customer.service';
import { DialogModule } from 'src/layout/dialog/dialog.module';
import { MediaModule } from 'src/layout/media/media.module';
import { CustomerLoginComponent } from '../customer-login/customer-login.component';
import { CustomerMenuComponent } from '../customer-menu/customer-menu.component';

@Component({
    selector: 'app-customer-button',
    standalone: true,
    imports: [TranslateModule,CustomerMenuComponent,CustomerLoginComponent, DialogModule, MediaModule],
    templateUrl: './customer-button.component.html',
    styleUrl: './customer-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerButtonComponent {

    constructor(
        public customerService: CustomerService,
    ) {}

    close(s:string) {
        window[s].close();
    }
}
